<template>
    <DDropdown
        id="user_dropdown"
        v-c-tooltip="__('messages.header.user_dropdown.title')"
        add-menu-classes="pt-0"
        icon="account-outline"
        color="secondary"
        :caret="true"
    >
        <DDropdownItem
            id="user-dropdown-profile"
            class="user-dropdown-item"
            @click="$inertia.get($route('users.edit', {user: userId}))"
        >
            <DIcon name="account" />
            <span>{{ userName }}</span>
        </DDropdownItem>
        <DDropdownItem
            id="user-dropdown-profile"
            class="user-dropdown-item"
            @click="$inertia.get($route('settings.dashboard-settings.create'))"
        >
            <DIcon name="cog-outline" />
            <span>
                {{ __('messages.sitemap.settings.dashboard_settings.dashboard_settings') }}
            </span>
        </DDropdownItem>
        <DDropdownItem
            id="user-dropdown-logout"
            class="user-dropdown-item"
            @click="logout"
        >
            <DIcon name="logout" />
            <span>{{ __('messages.header.user_dropdown.logout') }}</span>
        </DDropdownItem>
    </DDropdown>
</template>

<script>
export default {
    name: 'DUserDropdown',
    props: {
        userName: {
            type: String,
            required: false,
            default: ''
        },
        userId: {
            type: Number,
            default: 0
        },
        tenant: {
            type: String,
            required: false,
            default: 'Not selected'
        }
    },
    methods: {
        logout () {
            this.$inertia.get(this.$route('login.logout-hard'))
        }
    }
}
</script>

<style lang="scss" scoped>
.user-link {
    display: grid;
    grid-template-columns: auto 1fr;
    grid-gap: 0px 10px;
    border: 1px solid rgba(0,0,0,0.14);
    padding: 3px 10px;
    border-radius: 5px;
    height: 40px;
    justify-items: center;

    & div:nth-child(1) {
        color: rgba(0,0,0,0.4);
    }

    &:hover {
        background: rgba(0,0,0,0.07);
    }
}
.user-dropdown-item {
    display: grid;
    grid-template-columns: 20px 1fr;
    grid-gap: 15px;
    align-items: center;
}
</style>
